import { getFarmersList } from 'modules/domain/farmer/managers'
import { Farmer } from 'modules/domain/farmer/types'
import { Status } from 'types/entities'

const provinceCodes: Record<string, string> = {
  alberta: 'AB',
  'british columbia': 'BC',
  manitoba: 'MB',
  'new brunswick': 'NB',
  'newfoundland and labrador': 'NL',
  'northwest territories': 'NT',
  'nova scotia': 'NS',
  nunavut: 'NU',
  ontario: 'ON',
  'prince edward island': 'PE',
  quebec: 'QC',
  saskatchewan: 'SK',
  yukon: 'YT',
}

export function formatSeedOrderFarmerLabel(farmer: {
  first_name?: string | null
  last_name?: string | null
  farm_name?: string | null
  regions?: { title: string }[] | null
}): string {
  const name = [farmer.first_name, farmer.last_name].filter(Boolean).join(' ').trim()
  const provinces = Array.from(
    new Set(
      (farmer.regions ?? [])
        .map((region) => {
          const title = region.title.trim()
          return provinceCodes[title.toLowerCase()] ?? title
        })
        .filter(Boolean),
    ),
  ).join(', ')
  return [name, farmer.farm_name?.trim(), provinces].filter(Boolean).join(' - ')
}

export function buildSeedOrderFarmerOptions(farmers: Farmer[]): { label: string; value: string }[] {
  return farmers
    .filter((farmer) => farmer.status === Status.Active)
    .map((farmer) => {
      const name = [farmer.first_name, farmer.last_name].filter(Boolean).join(' ').trim()
      return {
        value: farmer.id,
        name,
        label: formatSeedOrderFarmerLabel(farmer) || farmer.id,
      }
    })
    .sort((first, second) => first.name.localeCompare(second.name, 'en', { sensitivity: 'base' }))
    .map(({ label, value }) => ({ label, value }))
}

export async function getSeedOrderFarmerOptions(): Promise<{ label: string; value: string }[]> {
  const response = await getFarmersList(
    { status: Status.Active },
    { sort_field: 'first_name', sort_reversed: false },
    1,
    5000,
  )
  return buildSeedOrderFarmerOptions(response.data ?? [])
}
